/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThreatIntentQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ThreatIntentQueryOperator");
    }

    getFixupPrototypeFunction() { return ThreatIntentQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ThreatIntentQueryOperator>): ThreatIntentQueryOperator {
        let obj = Object.assign(new ThreatIntentQueryOperator(), model);
        ThreatIntentQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThreatIntentQueryOperator>): ThreatIntentQueryOperator {
        if (!model) return null;
        return ThreatIntentQueryOperator.newInstance(<ThreatIntentQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThreatIntentQueryOperator) {
        if (!obj) return;

        models.ThreatIntentQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThreatIntentQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ThreatIntentQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Intents of the threat to include
     */
    intents: Array<string>;

}
